module.exports = __webpack_public_path__ + "static/EU_Logo-1f679d2040bac4084e5267d5a16ec2be.png";